// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3gm12","left":"InfoRow_left__NYFlz"};